<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <table class="login-layout" v-if="isUIReady"><!-- //NOSONAR -->
    <tr>
      <td class="login-right">
        <div class="login-content">
          <div class="login-header">
            <div>
              <div class="login-app-logo" />
            </div>
          </div>
          <div class="login-body">
            <!-- <div class="title">{{ $t('login.resetPassword.title') }}</div> -->
            <div v-if="isValidUuid" class="login-welcome">{{ $t('registration.welcome') }}</div>
            <div v-else class="login-welcome">
              {{ $t('registration.invalidTokenError') }}
            </div>
            <div v-if="isValidUuid">
              <el-form class="form" ref="form" :model="form" :rules="formRules">
                <div>
                  <div class="password-title">{{ $t('registration.newPassword') }}</div>
                  <el-form-item  prop="newPassword">
                    <el-input :type="newPasswordType" v-model="form.newPassword" :placeholder="$t('registration.newPasswordPlaceholder')" size="medium"></el-input>
                    <el-button :class="{'login-eye': true, 'login-eye-on': (newPasswordType=='text')}" @click="toggleNewPasswordVisibility"></el-button>
                  </el-form-item>
                  <div class="password-title">{{ $t('registration.confirmPassword') }}</div>
                  <el-form-item prop="newPasswordConfirm">
                    <el-input :type="confirmPasswordType" v-model="form.newPasswordConfirm" :placeholder="$t('registration.confirmPasswordPlaceholder')" size="medium"></el-input>
                    <el-button :class="{'login-eye': true, 'login-eye-on': (confirmPasswordType=='text')}" @click="toggleConfirmPasswordVisibility"></el-button>
                  </el-form-item>
                </div>
              </el-form>
              <div class="form-buttons">
                <el-button class="wy-blue-button" @click="handleUpdate" :loading="isLoading">{{ $t('button.confirm') }}</el-button>
                <el-button class="wy-grey-button" @click="handleCancel" :disabled="isLoading">{{ $t('button.cancel') }}</el-button>
              </div>
              <div class="login-password-hints">
                <div>
                  <div class="title">{{ $t('account.hints.passwordFormatTitle') }}</div>
                  <div class="desc" v-html="$t('account.hints.passwordFormatDesc')"></div>  
                </div> 
              </div>
            </div>
            <div v-else class="error-relogin">
              <el-button class="wy-blue-button" @click="handleCancel">{{ $t('button.returnToLoginPage') }}</el-button>
            </div>
          </div>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';

export default Vue.extend ({
  name: 'registration',
  data() {
    return {
      params: null,
      newPasswordType: 'password',
      confirmPasswordType: 'password',

      isUIReady: false,

      form: {
        currentPassword: '',
        newPassword: '',
        newPasswordConfirm: ''
      },
      formRules: {
        newPassword: [
          { validator: (rule, value, callback) => {
            this.$root.passwordValidator(value, callback)
          }, required: true, trigger: ['blur', 'change']}
        ],
        newPasswordConfirm: [
          { validator: (rule, value, callback) => {
            this.$root.passwordConfirm(this.form.newPassword, value, callback)    
          }, required: true, trigger: ['blur', 'change']}
        ]
      },
      isValidUuid: false,
      isLoading: false
    }
  },
  methods: {
    ...mapActions(['managementValidateRegistrationLink', 'createPassword']),

    toggleNewPasswordVisibility() {
      this.newPasswordType = (this.newPasswordType == 'password') ? 'text' : 'password';
    },
    toggleConfirmPasswordVisibility() {
      this.confirmPasswordType = (this.confirmPasswordType == 'password') ? 'text' : 'password';
    },
    redirLogin() {
      location.href = location.href.substr(0, location.href.indexOf('/#'));
    },    
    handleCancel() {
      this.$router.push({name: 'login'});
    },
    handleUpdate() {
      this.$refs.form.validate(async (isValid) => {
        if (isValid) {
          let msg = null;
          if(this.form.confirmPassword != ''){
            let data = {
              newPassword: this.form.newPassword,
              confirmPassword: this.form.newPasswordConfirm,
              email: this.params.userEmail
            };

            this.isLoading = true;
            let res = await this.createPassword(data);
            if(res && res.status == 200 && res.data.token) {
              this.$store.dispatch('amplitudeLog', {name: 'customer_login'});
              this.$router.push({path: '/default'});
            }
            else if(res.data && res.data.errorCode) {
              msg = this.$t(`errorCode.code${res.data.errorCode}`);
            }
            else {
              msg = this.$t('login.auth.incorrectInput');
              this.$store.dispatch('amplitudeLog', {name: 'invalid_credentials'});
            }
            this.isLoading = false;
          }
          return msg;
        }
      });      
    }
  },

  async created() {
    this.params = this.$route.query;

    if(this.params && this.params.userEmail && this.params.userId) {
      let res = await this.managementValidateRegistrationLink({email: this.params.userEmail, userId: this.params.userId})
      if(res.status === 200){
        this.isValidUuid = true;
      }else{
        this.isValidUuid = false;
      }
    }
    else {
      this.isValidUuid = false;
    }
    this.isUIReady = true;
    // if(document.querySelector('.wy-link-click')) {
    //   document.querySelector('.wy-link-click').addEventListener('click', this.redirLogin);
    // }
  },
  async mounted() {
  //   this.params = this.$route.query;

  //   if(this.params && this.params.userEmail && this.params.userId) {
  //     let res = await this.managementValidateRegistrationLink({email: this.params.userEmail, userId: this.params.userId})
  //     if(res.status === 200){
  //       this.isValidUuid = true;
  //     }else{
  //       this.isValidUuid = false;
  //     }
  //   }
  //   else {
  //     this.isValidUuid = false;
  //   }

  //   if(document.querySelector('.wy-link-click')) {
  //     document.querySelector('.wy-link-click').addEventListener('click', this.redirLogin);
  //   }
  }
})
</script>

<style lang="scss">
.wy-registration-page {
  overflow-y: auto;
  background-color: #0C2837;
  background-image: url('../assets/images/login_bg_owl.svg') !important;
  background-size: 48% 205%;
  background-repeat: no-repeat;
  background-position-x: 109%;
  background-position-y: 38.17%;
  .login-content {
    margin-top: 74px !important;
    .login-app-logo {
      width: 330px !important;
      height: 110px !important;
      background-image: var(--header-logo);
      background-size: 330px 77px;
      background-repeat: no-repeat;
    }
    .login-error {
      margin-top: 30px;
      font-size: 14px;
      text-align: center;
      .wy-link-click {
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .login-welcome {
      font-size: 16px;
      color: var(--site-font-primary-color);
      font-weight: 400;
    }

    .form {
      margin-top: 45px;
      .password-title {
        font-size: 14px;
        color: #214586;
        font-weight: 700;
        padding-top: 0px;    
        text-align: left;
      }
      .login-eye {
        background-image: url("../assets/images/login_eye.svg");
        background-position-x: 0px;
        background-position-y: 3px;
        background-repeat: no-repeat;
        padding: 10px 10px 10px 10px;
        margin: 0px;
        background-color: transparent;
        border: 0;
        position: relative;
        left: 263px;
        top: -44px;
      }
      .login-eye.login-eye-on {
        background-image: url("../assets/images/login_eye_on.svg");
      }
      .el-form-item {
        margin-bottom: 0px;
        margin-top: 8px;
        input.el-input__inner {
          border-width: 1px !important;
          height: 50px;
          border-radius: 5px;
        }
        .el-form-item__content {
          line-height: 25px;
        }
        .el-form-item__error {
          // position: relative;
          top: 52px;
        }
      }
    }
    .form-buttons {
      padding-top: 10px;
      .wy-blue-button{
        width: 100%;
        display: block;
        padding: 18px 30px 18px 30px;
      }
      .wy-grey-button{
        width: 100%;
        margin-left: 0px;
        margin-top: 10px;
        padding: 18px 30px 18px 30px;
        background: unset;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        border: 1px solid #ddd;
      }
    }

    .login-body {
      -webkit-box-shadow: -6px 0px 20px #1d1541;
      box-shadow: -6px 0px 20px #1d1541;
      border-radius: 5px;
      background: #FFFFFF;
      padding: 40px 40px;
      margin-top: 45px;
      width: 298px;
      height: fit-content;
      
      .mfa-title {
        color: #214586;
        font-size: 26px;
        margin-bottom: 5px;
      }
      .mfa-desc {
        margin-bottom: 5px;
      }
      .mfa-input {
        margin-top: 10px;
        margin-bottom: 20px;
      }
      .mfa-button {
        text-align: right;
      }

      .login-password-hints {
        margin-top: 34px !important;
        background-image: url('../assets/icons/alert_lock.svg');
        background-repeat: no-repeat;
        background-size: 31px 31px;
        background-position: 0px 0px;
        height: 85px;
        padding-left: 52px;
        padding-top: 1px;

        .title {
          font-size: 14px !important;
          font-weight: 700 !important;
        }
        .desc {
          font-size: 14px !important;
        }
      }
      .error-relogin {
        margin-top: 15px;
        .wy-blue-button {
          width: 100%;
          padding: 18px 30px 18px 30px;
          margin-top: 20px;
        }
      }
    }

    // .login-password-hints {
    //   margin-top: 34px !important;
    //   background-image: url('../assets/icons/alert_lock.svg');
    //   background-repeat: no-repeat;
    //   background-size: 31px 31px;
    //   background-position: 0px 0px;
    //   height: 55px;
    //   padding-left: 52px;
    //   padding-top: 1px;

    //   .title {
    //     font-size: 14px !important;
    //     font-weight: 700 !important;
    //   }
    //   .desc {
    //     font-size: 14px !important;
    //   }
    // }
    // .login-password-hints::before {
    //   content: '';
    //   background-image: url('../assets/icons/alert_lock.svg');
    //   background-repeat: no-repeat;
    //   background-size: 33px 33px;
    //   background-position: 0px 0px;
    //   height: 55px;
    //   width: 180px;
    //   margin-top: 5px;
    // }
  }
}
</style>